"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var SupportPlayerDetailsList = /** @class */ (function (_super) {
    __extends(SupportPlayerDetailsList, _super);
    function SupportPlayerDetailsList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchDescriptionInput = null;
        _this.searchTitleInput = null;
        return _this;
    }
    SupportPlayerDetailsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total_count
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            searchDescriptionFilter: [],
            searchDescriptionValue: "",
            searchTitleFilter: [],
            searchTitleValue: "",
            promo_part: ""
        }, function () {
            // this.props.data.LoadData(
            //     this.props.allBrands,
            //     this.props.brandsList
            // );
            //this.props.state.setExtBreadCrumbPath(["Наборы диапазонов фриспинов"]);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    SupportPlayerDetailsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    SupportPlayerDetailsList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize
            }, function () {
                //nextProps.data.LoadData(this.props.allBrands, this.props.brandsList);
            });
        }
    };
    SupportPlayerDetailsList.prototype.onClearDescriptionFilter = function () {
        this.setState({ searchDescriptionFilter: [], searchDescriptionValue: "" });
    };
    SupportPlayerDetailsList.prototype.onChangeDescriptionFilter = function (e) {
        this.setState({ searchDescriptionValue: e.target.value });
    };
    SupportPlayerDetailsList.prototype.onConfirmDescriptionFilter = function () {
        this.setState({ searchDescriptionFilter: [this.state.searchDescriptionValue] });
    };
    SupportPlayerDetailsList.prototype.onClearTitleFilter = function () {
        this.setState({ searchTitleFilter: [], searchTitleValue: "" });
    };
    SupportPlayerDetailsList.prototype.onChangeTitleFilter = function (e) {
        this.setState({ searchTitleValue: e.target.value });
    };
    SupportPlayerDetailsList.prototype.onConfirmTitleFilter = function () {
        this.setState({ searchTitleFilter: [this.state.searchTitleValue] });
    };
    SupportPlayerDetailsList.prototype.getColumns = function () {
        var _this = this;
        var _description_filter = this.state.searchDescriptionFilter;
        var _title_filter = this.state.searchTitleFilter;
        return [{
                title: 'Логин игрока',
                dataIndex: this.props.data.dk_player_login,
                key: this.props.data.dk_player_login,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchTitleInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043B\u043E\u0433\u0438\u043D\u0443", value: _this.state.searchTitleValue, onChange: _this.onChangeTitleFilter.bind(_this), onPressEnter: function () { _this.onConfirmTitleFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmTitleFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearTitleFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _title_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.player_login.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchTitleInput.focus();
                        });
                    }
                }
            }, {
                title: 'Почта игрока',
                dataIndex: this.props.data.dk_player_email,
                key: this.props.data.dk_player_email,
                width: 200,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchDescriptionInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043F\u043E\u0447\u0442\u0435", value: _this.state.searchDescriptionValue, onChange: _this.onChangeDescriptionFilter.bind(_this), onPressEnter: function () { _this.onConfirmDescriptionFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmDescriptionFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearDescriptionFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _description_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.player_email.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchDescriptionInput.focus();
                        });
                    }
                }
            }, {
                title: 'Бренд',
                dataIndex: this.props.data.dk_brand_title,
                key: this.props.data.dk_brand_title,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.brand_title));
                },
                width: 150,
            }, {
                title: 'Валюта',
                dataIndex: this.props.data.dk_player_currency_iso,
                key: this.props.data.dk_player_currency_iso,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.player_currency_iso));
                },
                width: 150,
            }, {
                title: 'Верифицирован',
                dataIndex: this.props.data.dk_is_verifed,
                key: this.props.data.dk_is_verifed,
                //render: (text, record, idx) => {
                //    return (
                //        <div>{record.promo_tpl_title}</div>
                //    )
                //},
                width: 150,
            }];
    };
    SupportPlayerDetailsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.props.data.LoadData({
                all_brands: _this.props.allBrands,
                brands_id_list: _this.props.brandsList,
                partial_email: _this.state.promo_part
            }, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, _PageSize);
                }
            });
        });
    };
    SupportPlayerDetailsList.prototype.loadData = function () {
        this.props.data.LoadData({
            all_brands: this.props.allBrands,
            brands_id_list: this.props.brandsList,
            partial_email: this.state.promo_part
        });
    };
    SupportPlayerDetailsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData();
        }
    };
    SupportPlayerDetailsList.prototype.OnBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    SupportPlayerDetailsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Почта игрока:", placeholder: "Введите почту игрока" }, value: this.state.promo_part, onValueChanged: function (newVal) {
                        _this.setState({ promo_part: newVal }, function () {
                            //this.loadData();
                        });
                    } }),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.OnBrandFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key_uid,
                            "] ")));
                }, scroll: { x: true } })));
    };
    return SupportPlayerDetailsList;
}(React.Component));
exports.default = SupportPlayerDetailsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/support_player_detail/ui/component/SupportPlayerDetailList.tsx
// module id = 2542
// module chunks = 0